import * as x from '../helpers/xmlHelpers';
import * as h from '../helpers/helpers';

export class NonContiguousParcelSeparator {
    constructor(doc)
    {
		this.label = null
		this.parcelSeparatorType = null
		this.parcelSeparatorTypeOtherDescription = null

		this.label = x.getStringAttribute(doc,"xlink:label");
		this.parcelSeparatorType = x.getStringElement(doc, "./ns:ParcelSeparatorType");
		this.parcelSeparatorTypeOtherDescription = x.getStringElement(doc, "./ns:ParcelSeparatorTypeOtherDescription");
   }
	GetSeparatorType() {
		return h.descriptionOrOther(this.parcelSeparatorType, this.parcelSeparatorTypeOtherDescription);
	}
	 
}

export class ParcelSummaryDetail {
    constructor(doc)
    {
		this.label = null
		this.parcelsLegalDescription = null

		this.label = x.getStringAttribute(doc,"xlink:label");
		this.parcelsLegalDescription = x.getStringElement(doc, "./ns:ParcelsLegalDescription");
   }
}

export class ParcelSummary {
    constructor(doc)
    {
		this.label = null
		this.nonContiguousParcelSeparators = []
		this.parcelSummaryDetail = null
		var node;
		var nodes;

		this.label = x.getStringAttribute(doc,"xlink:label");
		nodes = x.selectNodes(doc, "./ns:NON_CONTIGUOUS_PARCEL_SEPARATORS/ns:NON_CONTIGUOUS_PARCEL_SEPARATOR");
		if (nodes.length > 0)
		{
			nodes.forEach((xn) => {
				this.nonContiguousParcelSeparators.push(new NonContiguousParcelSeparator(xn));
			});
		}
		node = x.selectSingleNode(doc, "./ns:PARCEL_SUMMARY_DETAIL");
		if (node !== null)
				this.parcelSummaryDetail = new ParcelSummaryDetail(node);
   }

	 GetElementsDividingParcels() {
    let elements = '';

    // Check if NonContiguousParcelSeparators exists and is not empty
    if (this.nonContiguousParcelSeparators && this.nonContiguousParcelSeparators.length) {
        this.nonContiguousParcelSeparators.forEach(sep => {
            // Assuming getSeparatorType() exists on the separator objects
            elements = h.addWithSpacer(elements, sep.GetSeparatorType());
        });
    }
    return elements;
	}
}

